import { markingWordsHooks } from ".."


const useAudioActionBtns = () => {
    const saveDraft = markingWordsHooks.useMarkingAudioSaveDraft()
    const generateAudioAndVersion = markingWordsHooks.useGenerateAudioAndVersion()

    const audioActionBtns = [
        {
            label: "שמור סימונים כטיוטה",
            icon: <i className="fa-utility fa-semibold fa-floppy-disk" />,
            action: saveDraft.action,
            loading: saveDraft.isPending
        },
        {
            label: "צור אודיו נטו",
            icon: <i className="fa-regular fa-scissors" />,
            action: generateAudioAndVersion.action,
            loading: generateAudioAndVersion.isPending
        }
    ]

    return audioActionBtns
}

export default useAudioActionBtns